export default "__VITE_ASSET__Y_jM4Lua__"